module.exports = __webpack_public_path__ + "img/login_tab03_01.13b95ee7.png";